import { render } from "./CollectionTokens.vue?vue&type=template&id=072667dc"
import script from "./CollectionTokens.vue?vue&type=script&lang=js"
export * from "./CollectionTokens.vue?vue&type=script&lang=js"

import "./CollectionTokens.vue?vue&type=style&index=0&id=072667dc&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__